<script>
import forminput from "../formcomponet/forminput.vue";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";  
import dpagecategoriestranslations from "@/models/dpagecategoriestranslations";

export default {
  mixins: [apibtoast, apigeneric,dpagecategoriestranslations],
  props: ["DataId", "LanId"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      AddEdit:null,
      FormData: {}, 
      languages: {},
      dpagecategoriestranslationsData: [],
    };
  },
  components: {
    Loader,
    forminput, 
    
  },
  watch: {
    DataId() { 
      
    },
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.AddEdit == "Add") {
          this.Post("dpagecategoriestranslations", this.FormData).then((res) => {
            if (res) { 
              this.$emit("TableUpdate");  
            }
          });
        } else {
          this.Update("dpagecategoriestranslations", this.FormData).then((res) => {
            if (res) {
                
              this.$emit("TableUpdate");  
            }
          });
        }
      }
    },
    Get() {
      this.ActionsFilterGet({ Service: "dpagecategoriestranslations", Page: this.Page,
      Filter:"&Langid="+this.LanId+"&Dpagecategoryid="+this.DataId}).then((res) => {
        
        if(res.Data.length > 0){
        this.FormData = res.Data[0]; 
        this.AddEdit = "Edit"
        }
        else{  
          this.FormData = this.dpagecategoriestranslationsData
          this.AddEdit = "Add"
          this.FormData.Dpagecategoryid = this.DataId
          this.FormData.Langid = this.LanId 
          this.FormData.Websiteid = this.GettersWebsiteid 
        }
      });
    },
  
 
  },
};
</script>
<template>
  <Loader>  
      <Form @submit.prevent="onSubmit">  
        <div class="row"> 
          <div class="col-md-6">
            <forminput
              :FormDataType="FormDataType.Title"
              :Value="FormData.Title"
              :v="$v.FormData.Title"
              @input="FormData.Title = $event"
            />
          </div>
        </div> 
        <button class="btn btn-primary" type="submit">
          {{ $t("links.AddEdit.Button") }}
        </button>
      </Form>
 
  </Loader>
</template>
